import React from 'react';
import { StyleSheet, View } from 'react-native';
import Modal from 'utils/packages/Modal';
import { rem } from 'design-system/values';
import { IconEdit, IconTrash } from 'design-system/icons';
import { SettingsItem } from 'design-system/SettingsItem';
import PopUpMenuModal from 'design-system/PopUpMenuModal.web';
import { isWeb } from '../../../constants';
const strings = {
    editBudget: 'Edit budget',
    editBudgetSubtitle: 'Adjust your budgets and period',
    resetBudgeting: 'Reset budgeting',
    resetBudgetingSubTitle: 'Reset your current budgets and period',
};
const ModalToUse = isWeb ? PopUpMenuModal : Modal;
const ManageBudgetingModalContent = ({ onEditBudget, onResetBudget, }) => (<View style={styles.modalContent}>
    <SettingsItem light={isWeb} icon={<IconEdit gradientKey="darkPurple"/>} title={strings.editBudget} description={strings.editBudgetSubtitle} onPress={() => {
        ModalToUse.hide(() => onEditBudget?.());
    }}/>
    <SettingsItem light={isWeb} icon={<IconTrash colorKey="statusNegative"/>} title={strings.resetBudgeting} description={strings.resetBudgetingSubTitle} onPress={() => {
        ModalToUse.hide(() => onResetBudget?.());
    }}/>
  </View>);
export default ManageBudgetingModalContent;
const styles = StyleSheet.create({
    modalContent: {
        paddingTop: rem(isWeb ? 0 : 16),
    },
});
